"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _react = require("react");
var _css = require("@emotion/css");
var _useStylesUtils2 = require("../../hooks/useStylesUtils");
var _CetComponentsProvider = require("../../providers/CetComponentsProvider");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var useStyles = function useStyles(props) {
  var _useContext = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext),
    fontFamily = _useContext.fontFamily,
    themeColors = _useContext.themeColors;
  var _useStylesUtils = (0, _useStylesUtils2.useStylesUtils)(),
    pxToRem = _useStylesUtils.pxToRem,
    fontSizeProps = _useStylesUtils.fontSizeProps,
    getMeasurement = _useStylesUtils.getMeasurement,
    getElementHeight = _useStylesUtils.getElementHeight;
  var _props$isDisabled = props.isDisabled,
    isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled,
    _props$color = props.color,
    color = _props$color === void 0 ? 'primary' : _props$color,
    _props$shape = props.shape,
    shape = _props$shape === void 0 ? 'ellipse' : _props$shape,
    _props$size = props.size,
    size = _props$size === void 0 ? 'medium' : _props$size,
    _props$view = props.view,
    view = _props$view === void 0 ? 'contained' : _props$view,
    _props$pointerEvents = props.pointerEvents,
    pointerEvents = _props$pointerEvents === void 0 ? 'auto' : _props$pointerEvents,
    _props$customStyle = props.customStyle,
    customStyle = _props$customStyle === void 0 ? {} : _props$customStyle;
  var ccButtonStyle = (0, _react.useMemo)(function () {
    var shapeProps = function shapeProps() {
      var borderRadius;
      var aspectRatio;
      if (shape === 'rectangle' || view === 'link' || view === 'text') {
        borderRadius = 0;
      } else if (shape === 'round') {
        aspectRatio = '1';
        borderRadius = '50%';
      } else if (shape === 'roundedRectangle') {
        switch (size) {
          case 'x-small':
            borderRadius = pxToRem(3);
            break;
          case 'small':
            borderRadius = pxToRem(5);
            break;
          case 'medium':
          case 'large':
          case 'stretch':
            borderRadius = pxToRem(6);
            break;
          case 'x-large':
            borderRadius = pxToRem(8);
            break;
        }
      } else {
        borderRadius = pxToRem(25);
      }
      return {
        borderRadius: borderRadius,
        aspectRatio: aspectRatio
      };
    };
    var viewShapeSizeProps = function viewShapeSizeProps() {
      var padding;
      switch (size) {
        case 'x-small':
          padding = "0 ".concat(pxToRem(12));
          break;
        case 'small':
          padding = "0 ".concat(pxToRem(16));
          break;
        case 'medium':
          padding = "0 ".concat(pxToRem(24));
          break;
        case 'large':
          padding = "0 ".concat(pxToRem(24));
          break;
        case 'x-large':
          padding = "0 ".concat(pxToRem(28));
          break;
        case 'stretch':
          padding = 0;
      }
      var height = getElementHeight(size);
      var btnWidth = shape === 'round' || size === 'stretch' ? height : 'auto';
      if (view === 'link' || view === 'text') {
        padding = pxToRem(0);
        height = 'auto';
      } else {
        if (shape === 'round') {
          padding = pxToRem(4);
        }
      }
      return {
        height: height,
        width: btnWidth,
        maxWidth: '100%',
        padding: padding
      };
    };
    var colorViewProps = function colorViewProps() {
      var textColor;
      var background;
      var border;
      background = 'transparent';
      border = 'none';
      switch (color) {
        case 'primary':
          textColor = themeColors === null || themeColors === void 0 ? void 0 : themeColors.primary.main;
          switch (view) {
            case 'contained':
              background = "transparent linear-gradient(201.9deg, ".concat(themeColors === null || themeColors === void 0 ? void 0 : themeColors.primary.start, " 0%, ").concat(themeColors === null || themeColors === void 0 ? void 0 : themeColors.primary.end, " 100%) 0% 0% no-repeat padding-box");
              textColor = themeColors === null || themeColors === void 0 ? void 0 : themeColors.general.light;
              break;
            case 'outlined':
              border = "1px solid ".concat(themeColors === null || themeColors === void 0 ? void 0 : themeColors.primary.main);
              break;
            case 'alternate':
              background = themeColors === null || themeColors === void 0 ? void 0 : themeColors.primary.light;
              break;
            default:
              break;
          }
          break;
        case 'basic':
          textColor = themeColors === null || themeColors === void 0 ? void 0 : themeColors.general.text;
          switch (view) {
            case 'contained':
              background = themeColors === null || themeColors === void 0 ? void 0 : themeColors.basic.dark;
              textColor = themeColors === null || themeColors === void 0 ? void 0 : themeColors.general.light;
              break;
            case 'outlined':
              border = "1px solid ".concat(themeColors === null || themeColors === void 0 ? void 0 : themeColors.general.border);
              break;
            default:
              break;
          }
          break;
        default:
          break;
      }
      return {
        background: background,
        color: textColor,
        border: border
      };
    };
    var hoverColorViewProps = function hoverColorViewProps() {
      var backgroundColor = color === 'basic' && view === 'alternate' ? themeColors === null || themeColors === void 0 ? void 0 : themeColors.basic.main : color === 'primary' && view === 'alternate' ? themeColors === null || themeColors === void 0 ? void 0 : themeColors.primary.main : 'none';
      var textDecoration = view === 'link' ? 'underline' : 'none';
      if (view === 'alternate' && color === 'primary') {
        var _color = themeColors === null || themeColors === void 0 ? void 0 : themeColors.general.light;
        return {
          backgroundColor: backgroundColor,
          textDecoration: textDecoration,
          color: _color
        };
      }
      return {
        backgroundColor: backgroundColor,
        textDecoration: textDecoration
      };
    };
    var customStyleProps = function customStyleProps() {
      var customStyleObj = {}; //todo: fix type
      if (customStyle) {
        for (var _i = 0, _Object$entries = Object.entries(customStyle); _i < _Object$entries.length; _i++) {
          var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
            key = _Object$entries$_i[0],
            value = _Object$entries$_i[1];
          if (key === 'paddingInline') {
            customStyleObj[key] = getMeasurement(value);
          } else {
            customStyleObj[key] = value;
          }
        }
        return customStyleObj;
      }
      return {};
    };
    var disabledProps = function disabledProps() {
      if (isDisabled) {
        return {
          opacity: '.5',
          cursor: 'default'
        };
      }
      return {};
    };
    var ccButton = (0, _css.css)(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({
      position: 'relative',
      fontFamily: fontFamily,
      display: 'inline-flex',
      justifyContent: 'center',
      alignItems: 'center',
      textDecoration: 'none',
      cursor: 'pointer',
      backgroundColor: 'transparent',
      pointerEvents: pointerEvents
    }, fontSizeProps(size)), shapeProps()), viewShapeSizeProps()), colorViewProps()), customStyleProps()), disabledProps()), {}, {
      '&:focus': _objectSpread({}, hoverColorViewProps()),
      '&:hover': _objectSpread({}, hoverColorViewProps())
    }));
    return ccButton;
  }, [fontFamily, pointerEvents, fontSizeProps, size, shape, view, pxToRem, getElementHeight, color, themeColors === null || themeColors === void 0 ? void 0 : themeColors.primary.main, themeColors === null || themeColors === void 0 ? void 0 : themeColors.primary.start, themeColors === null || themeColors === void 0 ? void 0 : themeColors.primary.end, themeColors === null || themeColors === void 0 ? void 0 : themeColors.primary.light, themeColors === null || themeColors === void 0 ? void 0 : themeColors.general.text, themeColors === null || themeColors === void 0 ? void 0 : themeColors.general.light, themeColors === null || themeColors === void 0 ? void 0 : themeColors.general.border, themeColors === null || themeColors === void 0 ? void 0 : themeColors.basic.dark, themeColors === null || themeColors === void 0 ? void 0 : themeColors.basic.main, customStyle, getMeasurement, isDisabled]);
  return {
    'cc-Button': ccButtonStyle
  };
};
exports.useStyles = useStyles;
var _default = useStyles;
exports.default = _default;